export const formatNumber = (x = 0) => {
	return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 0
}
export const formatNumberWithIntl = (number) => {
	return new Intl.NumberFormat('fr-FR', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})
		.format(number)
		.replace(',', '.')
}

export function formatNumberWithIntlV2(number) {
	const parts = number.toString().split('.')
	parts[0] = new Intl.NumberFormat('en-US', { useGrouping: true })
		.format(parts[0])
		.replace(/,/g, ' ')
	return parts.join('.')
}

export function cleanedPhneNumber(input) {
	const cleaned = input
		.split(',')
		.map(
			(num) => num.replace(/\D/g, ''), // remove all non-digit characters
		)
		.join(', ')
	return cleaned
}
